// extracted by mini-css-extract-plugin
export var center = "_5z-2";
export var clickableRow = "_5z-5";
export var expandedRow = "_5z-7";
export var hoverable = "_5z-4";
export var left = "_5z-1";
export var right = "_5z-3";
export var row = "_5z-0";
export var selectedRow = "_5z-6";
export var summaryRow = "_5z-8";